<template>
  <div class="user-avatar">
    <component
      :is="hasTooltip ? 'm-tooltip' : 'div'"
      placement="top"
    >
      <m-avatar
        :size="size"
        :src="profileImage"
        :class="['user-avatar']"
        :bordered="bordered"
        :text="avatarText"
        black-and-white
        shape="circle"
      />
      <template
        v-if="hasTooltip"
        #title
      >
        {{ avatarText }}
      </template>
    </component>
  </div>
</template>

<script>
import useUser from 'shared/composables/user';
import { isNullOrUndefined } from 'shared/lib/object/object';
import { toRef } from 'vue';

export default {
  name: 'UserAvatar',
  props: {
    user: {
      validator: (prop) => typeof prop === 'object' || prop === null,
      required: true,
    },
    size: {
      type: Number,
      default: 24,
    },
    hasTooltip: {
      type: Boolean,
      default: false,
    },
    bordered: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const { displayName: avatarText } = useUser(toRef(props, 'user'));
    return { avatarText };
  },
  computed: {
    profileImage() {
      if (this.user === null) {
        return '';
      }

      if (!isNullOrUndefined(this.user.archivedAt)) {
        return new URL('@/assets/img/profile-image-archived.png', import.meta.url).href;
      }

      if (!isNullOrUndefined(this.user.profileImage)) {
        return this.user.profileImage.getURL;
      }
      return '';
    },
  },
};
</script>

<style scoped lang="scss" type="text/scss">
  .user-avatar {
    display: inline;
  }
</style>
